// let baseUrl='https://staging.okrcoach.app/api/';
// let baseUrl='https://omidapiokr.banksepah.net/api/';
let baseUrl='https://api.myokr.ir/api/';
// let baseUrl='https://localhost:7071/api/';
//  let baseUrl='https://apitest.myokr.ir/api/';
// let baseUrl='https://localhost:7071/api/';
// let baseUrl='https://localhost:485/api/';
//  let baseUrl='https://api.myokr.ir/api/';
const timerLong = 120;
const timerAlarmStart = 10;

// let baseUrl='https://apiokr.bhoholding.ir/api/';
// https://staging.okrcoach.app/api/
// https://omidtekapi.okrcoach.app/api/
// 09198297569
// ApiOKR.bhoholding.ir

export { baseUrl, timerLong, timerAlarmStart };
